import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-customergroups',
    templateUrl: './customergroups.component.html',
    styleUrls: ['./customergroups.component.scss'],
    standalone: false
})
export class CustomergroupsComponent implements OnInit {

  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("External Id", "ExternalId"),
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Description", "Description"),
    new Datalistviewcolumn("Total Spaces", "TotalSpaces"),
    new Datalistviewcolumn("Current Count", "OccupiedSpaces"),
    new Datalistviewcolumn("Available", "AvailableSpaces"),
    new Datalistviewcolumn("Reserved", "ReservedSpaces"),
    new Datalistviewcolumn("% Occupied", "PercentOccupied")
  ];

  ngOnInit(): void {
  }

} 
